import { Link } from 'gatsby';
import { PlaceCard } from "/src/components/PlaceCard";
import { getImage } from "gatsby-plugin-image";
import * as React from 'react';
export default {
  Link,
  PlaceCard,
  getImage,
  React
};